<div class="modal-container">
  <div class="modal-header">
    <h3 class="mat-h3">Edit Folder</h3>
  </div>

  <div class="modal-content">
    <form [formGroup]="editFolderForm">
      <div class="form-inputs">
        <span class="custom-label">Folder name</span>
        <mat-form-field class="gingr-input-wrapper form-field-full">
          <input matInput placeholder="name" type="text" formControlName="name" required />
          @if (name.invalid) {
            <mat-error>
              @if (name.errors?.required) {
                <span>Please enter name</span>
              }
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-inputs">
        <span class="custom-label">Keywords</span>
        <mat-form-field class="gingr-input-wrapper form-field-full">
          <mat-chip-grid #chipGrid aria-label="Keywords">
            @for (keyword of keywords; track keyword) {
              <mat-chip-row (removed)="removeKeyword(keyword)">
                {{ keyword }}
                <button matChipRemove>
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
            }
          </mat-chip-grid>
          <input
            placeholder="Add keyword..."
            #keywordInput
            [formControl]="keywordControl"
            [matChipInputFor]="chipGrid"
            [matChipInputSeparatorKeyCodes]="[13, 188]"
            (matChipInputTokenEnd)="addKeyword($event)"
            />
        </mat-form-field>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <div class="d-flex align-items-center justify-content-end">
      <button
        class="action-button"
        mat-raised-button
        color="accent"
        [disabled]="!!editFolderForm.invalid"
        (click)="updateFolder()"
        >
        Save
      </button>
      <button class="action-button" mat-stroked-button (click)="close()">Cancel</button>
    </div>
  </div>
</div>
